__webpack_require__.p = "/real-estate-fronted-app/";